var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zj-camera-player is-preview"},[_c('div',{ref:"player",on:{"dblclick":function($event){$event.stopPropagation();return _vm.onDblClick($event)}}}),_c('div',{ref:"imgdiv"})])}
var staticRenderFns = []

export { render, staticRenderFns }